import styled, { css } from "styled-components";
import { sm } from "styles/breakpoint";

export const DepositModalStyle = styled.div`
  height: 100%;
  & .deposit {
    &_modal {
      width: 100%;
      height: 100%;
      padding: 40px 25px;

      & .date__picker__deposit .ant-picker {
        background-color: rgb(98, 96, 96) !important;
      }
    }
    &_image {
      width: 100px;
      margin: 0 auto;
      margin-bottom: 30px;
      img {
        width: 100%;
        object-fit: cover;
      }
    }
    &_title {
      text-align: center;
      margin-bottom: 30px;
      font-size: 36px;
      font-weight: 500;
      line-height: 42px;
      letter-spacing: 0.02em;
      text-transform: uppercase;
      color: ${(props) => props.theme.text.white};
    }

    &_form {
      max-width: 600px;
      margin: 0 auto;

      &_information {
        margin-bottom: 8px;
      }

      & .ant-select-selector {
        background-color: rgb(98, 96, 96) !important;
      }

      & .form_amount {
        margin-bottom: 30px;
      }

      & .form_checkbox {
        margin-bottom: 20px;
      }

      & .form_bonus {
        text-align: center;
        & .bonus_title {
          color: ${(props) => props.theme.text.white};
          font-size: 24px;
          font-weight: 400;
          margin-bottom: 30px;
        }

        /* swiper overide*/
        & .swiper {
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.45);
          width: 300px;
          ${sm(css`
            width: auto;
          `)}
          &-pagination {
            &-bullet {
              background-color: ${(props) => props.theme.colors.white};
              opacity: 1;
              &-active {
                background-color: ${(props) => props.theme.colors.yellow};
              }
            }
          }

          &-button-prev,
          &-button-next {
            color: ${(props) => props.theme.colors.yellow};
            top: 100px;
            &::after {
              font-size: 28px;
              font-weight: bold;
            }
          }
        }
        /*  */
      }

      & .form_submit {
        margin-top: 40px;
        button {
          height: 40px;
          border-width: 2px;
        }
      }
      & .upload__deposit {
        & .ant-upload-list-item-name {
          color: white;
        }
        & .anticon.anticon-paper-clip {
          color: white;
        }

        & .ant-upload.ant-upload-select {
          width: 100%;
          height: 50px;
        }

        & .upload__button {
          border-color: transparent;
          background-color: rgb(98, 96, 96) !important;
          width: 100%;
          height: 100%;
          text-align: inherit;
          color: rgba(255, 255, 255, 0.5);
        }
      }
    }
  }
`;
export const DepositModalQROveride = css`
  & .deposit-QR-modal-wrapper {
    & .ant-modal {
      width: 800px !important;
      padding-bottom: 0;
      ${sm(css`
        width: 350px !important;
      `)}
      &-content {
        height: 100%;
        background-color: ${(props) => props.theme.colors.black300};
        & .ant-modal-close {
          background-color: unset;
          color: ${(props) => props.theme.text.white};
          &:hover {
            color: ${(props) => props.theme.colors.yellow};
          }
        }
        & .ant-modal-body {
          height: 100%;
        }
      }
    }
  }
`;

export const DepositModalOveride = css`
  & .deposit-modal-wrapper {
    & .ant-modal {
      width: 600px !important;
      padding-bottom: 0;
      ${sm(css`
        width: 350px !important;
      `)}
      &-content {
        height: 100%;
        background-color: ${(props) => props.theme.colors.black300};
        & .ant-modal-close {
          background-color: unset;
          color: ${(props) => props.theme.text.white};
          &:hover {
            color: ${(props) => props.theme.colors.yellow};
          }
        }
        & .ant-modal-body {
          height: 100%;
        }
      }
    }
  }
`;

export const SelectCustomStyle = styled.div`
  & .ant-select {
    width: 100%;
    &-selector {
      height: 50px !important;
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
      background-color: #3a3a3a !important;
      color: ${(props) => props.theme.text.white} !important;
      border-radius: 10px;
    }
    &-selection-item {
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.text.white} !important;
    }
    &-arrow {
      color: #ccc;
    }
    &-selection-placeholder {
      display: flex;
      align-items: center;
      color: ${(props) => props.theme.text.white} !important;
      opacity: 0.5;
    }

    // custom validate error
    &-status-error {
      .ant-select-selector {
        border: 1px solid ${(props) => props.theme.validate.error} !important;
        .ant-select-selection-placeholder {
          color: ${(props) => props.theme.validate.error} !important;
          opacity: 1;
        }
      }
      .ant-select-arrow {
        color: ${(props) => props.theme.validate.error};
      }
    }
  }
`;
